import { jsx } from "react/jsx-runtime";
import { c } from "react/compiler-runtime";
import { createContext } from "react";
const HostContext = createContext(null);
const HostProvider = (t0) => {
  const $ = c(7);
  const {
    children,
    onNavigate,
    components,
    helpContent
  } = t0;
  let t1;
  if ($[0] !== components || $[1] !== helpContent || $[2] !== onNavigate) {
    t1 = {
      onNavigate,
      components,
      helpContent
    };
    $[0] = components;
    $[1] = helpContent;
    $[2] = onNavigate;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== t1) {
    t2 = /* @__PURE__ */ jsx(HostContext.Provider, { value: t1, children });
    $[4] = children;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export {
  HostContext,
  HostProvider
};
